export class Footprint {
    id: string;
    nutrient: string;
    value: number;
    category: string;
    subCategory: string;
    source: string;
    get sourceDisplay(): string { return this.convertSource(); }
    hint: string;

    constructor(i?: IFootprint) {
        if (i) {
            Object.assign(this, i);
        }
    }

    toInterface(): IFootprint {
        const ret = {} as IFootprint;
        Object.assign(ret, this);
        return ret;
    }

    private convertSource(): string {
        if (this.source === 'https://www.ifeu.de/projekt/oekologischer-fussabdruck-von-lebensmitteln-und-gerichten-in-deutschland/') {
            return 'IFEU';
        }
        return this.source;
    }
}

export interface IFootprint {
    id: string;
    nutrient: string;
    value: number;
    category: string;
    subCategory: string;
    source: string;
    hint: string;
}
